<template>
<div>
    <div v-if="contract" class="full split-bottom">
        <div class="header">
            <div class="label">Aktiver Vertrag</div>
            <div class="header-right">
                <div class="button small" @click="showModal('modal-editorend')">
                    <div class="label">
                        Vertrag bearbeiten
                    </div>
                </div>
            </div>
        </div>
        <div class="third left">
            <div class="full">
                <div class="third left">
                    <div class="label">Beruf</div>
                </div>
                <div class="twothirds right">
                    <div class="label data">{{ contract.jobName }}</div>
                </div>
            </div>
            <div class="full split-bottom-tight">
                <div class="third left">
                    <div class="label">Kategorie</div>
                </div>
                <div class="twothirds right">
                    <div class="label data">{{ employeeCategoryMap[contract.employeeCategory] }}</div>
                </div>
            </div>
            <div class="full">
                <div class="third left">
                    <div class="label">Vertragstyp</div>
                </div>
                <div class="twothirds right">
                    <div class="label data">{{ contractTypeMap[contract.contractType] }}</div>
                </div>
            </div>
            <div class="full split-bottom">
                <div class="third left">
                    <div class="label">Anstellungsart</div>
                </div>
                <div class="twothirds right">
                    <div class="label data">{{ employmentTypeMap[contract.employmentType] }}</div>
                </div>
            </div>
        </div>
        <div class="third mid">
            <div class="full">
                <div class="third left">
                    <div class="label">Eintritt</div>
                </div>
                <div class="twothirds right">
                    <div class="label data">{{ $helpers.extractDateString(contract.from, 'DD.MM.YYYY') }}</div>
                </div>
            </div>
            <div v-if="contract.probationTo" class="full" v-bind:class="{'split-bottom': !contract.to}">
                <div class="third left">
                    <div class="label">Probezeit bis</div>
                </div>
                <div class="twothirds right">
                    <div class="label data">{{ $helpers.extractDateString(contract.probationTo, 'DD.MM.YYYY') }}</div>
                </div>
            </div>
            <div v-if="contract.to" class="full split-bottom-tight">
                <div class="third left">
                    <div class="label">Vertragsende</div>
                </div>
                <div class="twothirds right">
                    <div class="label data">{{ $helpers.extractDateString(contract.to, 'DD.MM.YYYY') }}</div>
                </div>
            </div>
            <div class="full">
                <div class="third left">
                    <div class="label">Wochenstunden</div>
                </div>
                <div class="twothirds right">
                    <div class="label data">{{ minutesToHours(contract.weekTimeRegular) }}</div>
                </div>
            </div>
            <div class="full">
                <div class="third left">
                    <div class="label">Arbeitstage</div>
                </div>
                <div class="twothirds right">
                    <div class="label data">{{ contract.weekWorkDaysRegular }}</div>
                </div>
            </div>
            <div class="full split-bottom">
                <div class="third left">
                    <div class="label">Urlaubstage</div>
                </div>
                <div class="twothirds right">
                    <div class="label data">{{ minutesToDays(contract.vacationTime) }}</div>
                </div>
            </div>
        </div>
        <div class="third right">
            <div v-if="contractFile && contract && contract.fileId && contractFile.id == contract.fileId" class="full">
                <div class="full">
                    <div class="half left">
                        <div class="label">Dokument vorhanden</div>
                    </div>
                    <div class="half">
                        <div class="button small" @click="openContractFile()">
                            <div class="label">
                                Vertragsdokument öffnen
                            </div>
                        </div>
                    </div>
                </div>
                <div class="full split-bottom-tight">
                    <div class="half left">
                        <div class="label">Vertrag hochgeladen</div>
                    </div>
                    <div class="half">
                        <div class="label data">{{ $helpers.extractDateString(contractFile.creationDate, "DD.MM.YYYY | HH:mm") }}</div>
                    </div>
                </div>
                <div v-if="!contract.approved || !checkApprovalDate(contract)" class="full split-bottom">
                    <div class="half left">
                        <div class="label">Dokument nicht bestätigt</div>
                    </div>
                    <div class="half">
                        <div class="button small" @click="approveContractFile(contract)">
                            <div class="label">
                                Dokument jetzt bestätigen
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else class="full split-bottom">
                    <div class="half left">
                        <div class="label">bestätigt am</div>
                    </div>
                    <div class="half">
                        <div class="label data">{{ $helpers.extractDateString(contract.approvalDate, "DD.MM.YYYY | HH:mm") }}</div>
                    </div>
                </div>
            </div>
            <div v-else class="full">
                <div class="half left">
                    <div class="label">Kein Dokument vorhanden</div>
                </div>
                <div class="half">
                    <div class="button small" @click="selectFileForUpload(contract)">
                        <div class="label">
                            Jetzt hochladen
                        </div>
                    </div>
                </div>
            </div>
            
        </div>
        <div class="full">
            <div class="third left">
                <div class="full">
                    <div class="header">
                        <div class="label">Zahlung</div>
                    </div>
                    <div class="third left">
                        <div class="label">Zahlungstyp</div>
                    </div>
                    <div class="twothirds right">
                        <div class="label data">{{ paymentTypeMap[contract.paymentType] }}</div>
                    </div>
                </div>
                <div class="full">
                    <div class="third left">
                        <div class="label">Zahlung</div>
                    </div>
                    <div class="twothirds right">
                        <div class="label data">{{ contract.payment }}</div>
                    </div>
                </div>
            </div>
            <div class="third mid">
                <div class="full">
                    <div class="header">
                        <div class="label">Überstundenzuschläge</div>
                    </div>
                    <div class="half left">
                        <div class="label">Bonus pro Stunde</div>
                    </div>
                    <div class="half right">
                        <div class="label data">{{ contract.overtimeBonusHour }}</div>
                    </div>
                </div>
                <div class="full">
                    <div class="half left">
                        <div class="label">Bonus pauschal</div>
                    </div>
                    <div class="half right">
                        <div class="label data">{{ contract.overtimeBonusShift }}</div>
                    </div>
                </div>
            </div>
            <div class="third right">
                <div class="full">
                    <div class="header">
                        <div class="label">Nachtarbeit & Zuschläge</div>
                    </div>
                </div>
                <div class="full">
                    <div class="half left">
                        <div class="label">Tag/Nacht</div>
                    </div>
                    <div class="half right">
                        <div class="label data">{{ nightWorkerTypeMap[contract.nightWorkerType] }}</div>
                    </div>
                </div>
                <div class="full">
                    <div class="half left">
                        <div class="label">Bonus pro Stunde</div>
                    </div>
                    <div class="half right">
                        <div class="label data">{{ contract.nightWorkBonusHour }}</div>
                    </div>
                </div>
                <div class="full">
                    <div class="half left">
                        <div class="label">Bonus pauschal</div>
                    </div>
                    <div class="half right">
                        <div class="label data">{{ contract.nightWorkBonusShift }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div v-else class="full split-bottom">
        <div class="twothirds left">
            <div v-if="!futureContracts || futureContracts.length == 0" class="full">
                <div class="header">
                    <div class="label">Arbeitsvertrag anlegen</div>
                    <div class="header-right">
                        <div class="button small right" style="margin-right: 0px;" @click="openNewContractWizard()">
                            <div class="label">
                                Vertrag erstellen
                            </div>
                        </div>
                    </div>
                </div>
                <div class="full">
                    <div class="label">Kein aktiver Arbeitsvertrag vorhanden</div>
                </div>
            </div>
            <div v-else class="full">
                <div class="header">
                    <div class="label">Arbeitsvertrag anlegen</div>
                </div>
                <div class="twothirds left">
                    <div class="label">{{ 'Der Arbeitsvertrag beginnt am ' + formattedDate(upcomingContract.from) }}</div>
                </div>
                <div class="third right">
                    <div class="button small right" style="margin-right: 0px;" @click="openDetails(upcomingContract)">
                        <div class="label">
                            Details anzeigen
                        </div>
                    </div>
                </div>
            </div>
            <div class="full">
            </div>
        </div>
    </div>
    <div v-if="futureContracts != undefined && futureContracts.length > 0" class="full">
        <div class="header">
            <div class="label">Zukünftige Arbeitsverträge</div>
        </div>
        <b-table class="documents" striped hover :borderless="true" :outlined="false" :items="futureContracts" :fields="fieldsFuture">
            <template slot="fileId" slot-scope="row">
                <div style="text-align: left; margin-left: 20px;">
                <i class="fas fa-check-circle checkIcon coredata" v-bind:class="{'true' : row.item.fileId, 'false' : !row.item.fileId}"></i>
                </div>
            </template>
            <template slot="actions" slot-scope="row">
                <div class="button small mright8" v-on:click="openDetails(row.item)"><div class="label">Details</div></div>
                <div v-if="row.item.fileId" class="button small mright8" v-on:click="loadAndOpenContractFile(row.item)"><div class="label">Dokument öffnen</div></div>
                <div v-else class="button small mright8" v-on:click="selectFileForUpload(row.item)"><div class="label">Dokument hochladen</div></div>
                <div v-if="row.item.fileId && (!row.item.approved || !checkApprovalDate(row.item))" class="button small mright8" v-on:click="approveContractFile(row.item)"><div class="label">Bestätigen</div></div>
                <div v-else-if="row.item.fileId && row.item.approved && checkApprovalDate(row.item)" class="button small mright8 disabled"><div class="label">Bestätigt</div></div>
                <div v-if="!row.item.fileId || (row.item.fileId && (!row.item.approved || !checkApprovalDate(row.item)))" class="button small mright8" v-on:click="contractToDelete = row.item; showModal('modal-deletecontract');"><div class="label">Löschen</div></div>
            </template>
        </b-table>
    </div>
    <div v-if="pastContracts != undefined && pastContracts.length > 0" class="full">
        <div class="header">
            <div class="label">Vergangene Arbeitsverträge</div>
        </div>
        <b-table class="documents" striped hover :borderless="true" :outlined="false" :items="pastContracts" :fields="fieldsPast">
            <template slot="fileId" slot-scope="row">
                <div style="text-align: left; margin-left: 20px;">
                <i class="fas fa-check-circle checkIcon coredata" v-bind:class="{'true' : row.item.fileId, 'false' : !row.item.fileId}"></i>
                </div>
            </template>
            <template slot="actions" slot-scope="row">
                <div class="button small mright8" v-on:click="openDetails(row.item)"><div class="label">Details</div></div>
                <div v-bind:class="{disabled: !row.item.fileId}" class="button small mright8" v-on:click="loadAndOpenContractFile(row.item)"><div class="label">Dokument öffnen</div></div>
            </template>
        </b-table>
    </div>
    <b-modal size="employeewizard" ref="modal-createcontract" no-close-on-backdrop no-close-on-esc centered :hide-header="true" :hide-footer="true">
        <div class="wizard-popup">
            <b-row>
                <b-col>
                    <div class="header main">
                        <div class="label">Neuen Arbeitsvertrag anlegen</div>
                    </div>
                    <div class="close" v-on:click="hideModal('modal-createcontract');">
                        <i class="fas fa-times"></i>
                    </div>
                </b-col>
            </b-row>
            <div v-show="wizardPage == 1">
                <b-row>
                    <b-col>
                        <div class="full split-bottom">
                            <div class="header">
                                <div class="label">Grunddaten</div>
                            </div>
                            <div class="half left">
                                <div class="third left">
                                    <div class="label">Beruf</div>
                                </div>
                                <div class="twothirds cd-input" v-bind:class="{bottomline: $helpers.isEmpty(newContract.jobName)}">
                                    <input @focus="toggleInputPopup('jobName', false)" id="wizard-jobName" type="text" v-model="newContract.jobName"/>
                                </div>
                            </div>
                            <div class="half">
                                <div class="half">
                                    <div class="label">Anstellungsart</div>
                                </div>
                                <div @click="toggleInputPopup('employmentType', false)" class="half" style="z-index: 1000;">
                                    <searchbar id="wizard-employmentType" class="filters" ref="filtersEmploymentType" :searchbar="filtersEmploymentType"/>
                                </div>
                            </div>
                            <div class="half left">
                                <div class="third left">
                                    <div class="label">Kategorie</div>
                                </div>
                                <div @click="toggleInputPopup('employeeCategory', false)" class="twothirds" style="z-index: 900;">
                                    <searchbar id="wizard-employeeCategory" class="filters" ref="filtersEmployeeCategory" :searchbar="filtersEmployeeCategory"/>
                                </div>
                            </div>
                            <div class="half">
                                <div class="half">
                                    <div class="label">Vertragstyp</div>
                                </div>
                                <div @click="toggleInputPopup('contractType', false)" class="half" style="z-index: 900;">
                                    <searchbar id="wizard-contractType" class="filters" ref="filtersContractType" :searchbar="filtersContractType"/>
                                </div>
                            </div>
                        </div>
                        <div class="full">
                            <div class="header">
                                <div class="label">Gültigkeit & Probezeit</div>
                            </div>
                            <div class="half left">
                                <div class="third left">
                                    <div class="label">Eintritt:</div>
                                </div>
                                <div class="twothirds cd-input">
                                    <input @focus="toggleInputPopup('from', false)" id="wizard-from" type="date" v-model="fromDate"/>
                                </div>
                            </div>
                            <div v-show="newContract.employmentType == 2" class="half">
                                <div class="half left">
                                    <div class="label">Vertragsende:</div>
                                </div>
                                <div class="half cd-input">
                                    <input @focus="toggleInputPopup('to', false)" id="wizard-to" type="date" v-model="toDate"/>
                                </div>
                            </div>
                        </div>
                        <div class="full split-bottom">
                            <div class="half left">
                                <div class="third left">
                                    <div class="label">Probezeit</div>
                                </div>
                                <div class="twothirds cd-input">
                                    <i class="fas fa-check-circle checkbox coredata" @click="probationEnabled = !probationEnabled" v-bind:class="{'true' : probationEnabled, 'false' : !probationEnabled}"></i>
                                </div>
                            </div>
                            <div v-show="probationEnabled" class="half">
                                <div class="half left">
                                    <div class="label">Probezeit bis:</div>
                                </div>
                                <div class="half cd-input">
                                    <input @focus="toggleInputPopup('probationTo', false)" id="wizard-probationTo" type="date" v-model="newContract.probationTo"/>
                                </div>
                            </div>
                        </div>
                        <div class="full split-bottom">
                            <div class="header">
                                <div class="label">Kollektivvertrag</div>
                            </div>
                            <div class="full">
                                <div class="fourth left">
                                    <div class="label">Vertrag wählen</div>
                                </div>
                                <div @click="toggleInputPopup('collectiveContract', false)" class="twofourths" style="z-index: 1000;">
                                    <searchbar id="wizard-collectiveContract" class="filters" ref="filtersCollectiveContract" :searchbar="filtersCollectiveContract"/>
                                </div>
                            </div>
                            <div v-if="newContract.collectiveContract != undefined" class="full">
                                <div class="half left">
                                    <div class="half left">
                                        <div class="label">Wochenstunden</div>
                                    </div>
                                    <div class="half cd-input">
                                        <input id="wizard-payment" disabled type="text" v-model="weekTimeRegularHours"/>
                                    </div>
                                </div>
                                <div class="half">
                                    <div class="half left">
                                        <div class="label">Tage/Woche</div>
                                    </div>
                                    <div class="half cd-input">
                                        <input id="wizard-payment" disabled type="text" v-model="newContract.collectiveContract.weekWorkDaysRegular"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </b-col>
                </b-row>
                <b-popover custom-class="missing-input-popup" :show.sync="popupJobName" :disabled="popupdisabled" target="wizard-jobName" content="Beruf angeben" placement="top"></b-popover>
                <b-popover custom-class="missing-input-popup" :show.sync="popupEmploymentType" :disabled="popupdisabled" target="wizard-employmentType" content="Anstellungsart auswählen" placement="top"></b-popover>
                <b-popover custom-class="missing-input-popup" :show.sync="popupEmployeeCategory" :disabled="popupdisabled" target="wizard-employeeCategory" content="Kategorie auswählen" placement="top"></b-popover>
                <b-popover custom-class="missing-input-popup" :show.sync="popupContractType" :disabled="popupdisabled" target="wizard-contractType" content="Vertragstyp auswählen" placement="top"></b-popover>
                <b-popover custom-class="missing-input-popup" :show.sync="popupFrom" :disabled="popupdisabled" target="wizard-from" content="Eintrittsdatum angeben" placement="top"></b-popover>
                <b-popover custom-class="missing-input-popup" :show.sync="popupTo" :disabled="popupdisabled" target="wizard-to" content="Vertragsende angeben" placement="top"></b-popover>
                <b-popover custom-class="missing-input-popup" :show.sync="popupProbationTo" :disabled="popupdisabled" target="wizard-probationTo" content="Ende der Probezeit angeben" placement="top"></b-popover>
                <b-popover custom-class="missing-input-popup" :show.sync="popupCollectiveContract" :disabled="popupdisabled" target="wizard-collectiveContract" content="Kollektivvertrag auswählen" placement="top"></b-popover>

            </div>
            <div v-show="wizardPage == 2">
                <b-row>
                    <b-col>
                        <div class="full split-bottom">
                            <div class="header">
                                <div class="label">Urlaubsanspruch</div>
                            </div>
                            <div class="full">
                                <div class="half left">
                                    <div class="half left">
                                        <div class="label">Urlaubstage</div>
                                    </div>
                                    <div class="half cd-input" v-bind:class="{bottomline: $helpers.isEmpty(newContract.vacationTime)}">
                                        <input @focus="toggleInputPopup('vacationTime', false)" id="wizard-vacationTime" type="text" v-model="vacationTimeDays"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="full split-bottom">
                            <div class="header">
                                <div class="label">Lohn/Gehalt</div>
                            </div>
                            <div class="half left">
                                <div class="half left">
                                    <div class="label">Zahlungstyp</div>
                                </div>
                                <div @click="toggleInputPopup('paymentType', false)" class="half" style="z-index: 900;">
                                    <searchbar id="wizard-paymentType" class="filters" ref="filtersPaymentType" :searchbar="filtersPaymentType"/>
                                </div>
                            </div>
                            <div class="half left">
                                <div class="half left">
                                    <div class="label">Zahlung</div>
                                </div>
                                <div class="half cd-input" v-bind:class="{bottomline: $helpers.isEmpty(newContract.payment)}">
                                    <input @focus="toggleInputPopup('payment', false)" id="wizard-payment" type="text" v-model="newContract.payment"/>
                                </div>
                            </div>
                        </div>
                        <div class="full split-bottom">
                            <div class="half left">
                                <div class="header">
                                    <div class="label">Überstundenzuschläge</div>
                                </div>
                                <div class="full">
                                    <div class="twothirds left">
                                        <div class="label">Bonus pro Stunde</div>
                                    </div>
                                    <div class="third cd-input" v-bind:class="{bottomline: $helpers.isBlank(newContract.overtimeBonusHour)}">
                                        <input id="wizard-overtimeBonusHour" type="text" v-model="newContract.overtimeBonusHour"/>
                                    </div>
                                </div>
                                <div class="full">
                                    <div class="twothirds left">
                                        <div class="label">pauschal</div>
                                    </div>
                                    <div class="third cd-input" v-bind:class="{bottomline: $helpers.isBlank(newContract.overtimeBonusShift)}">
                                        <input id="wizard-overtimeBonusShift" type="text" v-model="newContract.overtimeBonusShift"/>
                                    </div>
                                </div>
                            </div>
                            <div class="half left">
                                <div class="header">
                                    <div class="label">Nachtarbeit & Zuschläge</div>
                                </div>
                                <div class="full">
                                    <div class="twothirds left">
                                        <div class="label">Nachtarbeiter</div>
                                    </div>
                                    <div class="third">
                                        <i class="fas fa-check-circle checkbox coredata" @click="(newContract.nightWorkerType == 1)? newContract.nightWorkerType = 2 : newContract.nightWorkerType = 1;" v-bind:class="{'true' : newContract.nightWorkerType == 2, 'false' : newContract.nightWorkerType == 1}"></i>
                                    </div>
                                </div>
                                <div class="full">
                                    <div class="twothirds left">
                                        <div class="label">Bonus pro Stunde</div>
                                    </div>
                                    <div class="third cd-input" v-bind:class="{bottomline: $helpers.isBlank(newContract.nightWorkBonusHour)}">
                                        <input id="wizard-nightWorkBonusHour" type="text" v-model="newContract.nightWorkBonusHour"/>
                                    </div>
                                </div>
                                <div class="full">
                                    <div class="twothirds left">
                                        <div class="label">pauschal</div>
                                    </div>
                                    <div class="third cd-input" v-bind:class="{bottomline: $helpers.isBlank(newContract.nightWorkBonusShift)}">
                                        <input id="wizard-nightWorkBonusShift" type="text" v-model="newContract.nightWorkBonusShift"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </b-col>
                </b-row>
                <b-popover custom-class="missing-input-popup" :show.sync="popupVacationTime" :disabled="popupdisabled" target="wizard-vacationTime" content="Urlaubsanspruch angeben" placement="top"></b-popover>
                <b-popover custom-class="missing-input-popup" :show.sync="popupPaymentType" :disabled="popupdisabled" target="wizard-paymentType" content="Zahlungstyp auswählen" placement="top"></b-popover>
                <b-popover custom-class="missing-input-popup" :show.sync="popupPayment" :disabled="popupdisabled" target="wizard-payment" content="Betrag angeben" placement="top"></b-popover>
            </div>
            <div v-show="wizardPage == 3" style="height: 200px;">
                <div class="loading">
                    <i class="fas fa-spinner"></i>
                </div>
            </div>
            <b-row>
                <b-col>
                    <div class="footer right">
                        <div v-if="wizardPage > 1" class="button next" v-bind:class="{disabled: wizardPage == 3}" @click="wizardPrev()">
                            <div class="label">Zurück</div>
                        </div>
                        <div class="button next" v-bind:class="{green: wizardPage == 2, disabled: wizardPage == 3}" @click="wizardNext()">
                            <div class="label">{{ wizardPage >= 2? 'Speichern' : 'Weiter' }}</div>
                        </div>
                    </div>
                </b-col>
            </b-row>
        </div>
    </b-modal>
    <b-modal size="employeewizard" ref="modal-editcontract" no-close-on-backdrop no-close-on-esc centered :hide-header="true" :hide-footer="true">
        <div class="wizard-popup">
            <b-row>
                <b-col>
                    <div class="header main">
                        <div class="label">Arbeitsvertrag bearbeiten</div>
                    </div>
                    <div class="close" v-on:click="hideModal('modal-editcontract');">
                        <i class="fas fa-times"></i>
                    </div>
                </b-col>
            </b-row>
            <div v-show="wizardPage == 1">
                <b-row>
                    <b-col>
                        <div class="full split-bottom">
                            <div class="header">
                                <div class="label">Grunddaten</div>
                            </div>
                            <div class="half left">
                                <div class="third left">
                                    <div class="label">Beruf</div>
                                </div>
                                <div class="twothirds cd-input" v-bind:class="{bottomline: $helpers.isEmpty(newContract.jobName)}">
                                    <input @focus="toggleInputPopup('jobName', false)" id="wizard-jobName" type="text" v-model="newContract.jobName"/>
                                </div>
                            </div>
                            <div class="half">
                                <div class="half">
                                    <div class="label">Anstellungsart</div>
                                </div>
                                <div @click="toggleInputPopup('employmentType', false)" class="half" style="z-index: 1000;">
                                    <searchbar id="wizard-employmentType" class="filters" ref="filtersEmploymentType" :searchbar="filtersEmploymentType"/>
                                </div>
                            </div>
                            <div class="half left">
                                <div class="third left">
                                    <div class="label">Kategorie</div>
                                </div>
                                <div @click="toggleInputPopup('employeeCategory', false)" class="twothirds" style="z-index: 900;">
                                    <searchbar id="wizard-employeeCategory" class="filters" ref="filtersEmployeeCategory" :searchbar="filtersEmployeeCategory"/>
                                </div>
                            </div>
                            <div class="half">
                                <div class="half">
                                    <div class="label">Vertragstyp</div>
                                </div>
                                <div @click="toggleInputPopup('contractType', false)" class="half" style="z-index: 900;">
                                    <searchbar id="wizard-contractType" class="filters" ref="filtersContractType" :searchbar="filtersContractType"/>
                                </div>
                            </div>
                        </div>
                        <div class="full split-bottom">
                            <div class="header">
                                <div class="label">Gültigkeit</div>
                            </div>
                            <div v-show="newContract.employmentType != 2" class="full">
                                <div class="label">
                                    Wählen Sie den Vertragstyp "Befristet" um ein Vertragsende festzulegen
                                </div>
                            </div>
                            <div v-show="newContract.employmentType == 2" class="half">
                                <div class="half left">
                                    <div class="label">Vertragsende:</div>
                                </div>
                                <div class="half cd-input">
                                    <input @focus="toggleInputPopup('to', false)" id="wizard-to" type="date" v-model="toDate"/>
                                </div>
                            </div>
                        </div>
                        <div class="full split-bottom">
                            <div class="header">
                                <div class="label">Kollektivvertrag</div>
                            </div>
                            <div class="full">
                                <div class="fourth left">
                                    <div class="label">Vertrag wählen</div>
                                </div>
                                <div @click="toggleInputPopup('collectiveContract', false)" class="twofourths" style="z-index: 1000;">
                                    <searchbar id="wizard-collectiveContract" class="filters" ref="filtersCollectiveContract" :searchbar="filtersCollectiveContract"/>
                                </div>
                            </div>
                            <div v-if="newContract.collectiveContract != undefined" class="full">
                                <div class="half left">
                                    <div class="half left">
                                        <div class="label">Wochenstunden</div>
                                    </div>
                                    <div class="half cd-input">
                                        <input id="wizard-payment" disabled type="text" v-model="weekTimeRegularHours"/>
                                    </div>
                                </div>
                                <div class="half">
                                    <div class="half left">
                                        <div class="label">Tage/Woche</div>
                                    </div>
                                    <div class="half cd-input">
                                        <input id="wizard-payment" disabled type="text" v-model="newContract.collectiveContract.weekWorkDaysRegular"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </b-col>
                </b-row>
                <b-popover custom-class="missing-input-popup" :show.sync="popupJobName" :disabled="popupdisabled" target="wizard-jobName" content="Beruf angeben" placement="top"></b-popover>
                <b-popover custom-class="missing-input-popup" :show.sync="popupEmploymentType" :disabled="popupdisabled" target="wizard-employmentType" content="Anstellungsart auswählen" placement="top"></b-popover>
                <b-popover custom-class="missing-input-popup" :show.sync="popupEmployeeCategory" :disabled="popupdisabled" target="wizard-employeeCategory" content="Kategorie auswählen" placement="top"></b-popover>
                <b-popover custom-class="missing-input-popup" :show.sync="popupContractType" :disabled="popupdisabled" target="wizard-contractType" content="Vertragstyp auswählen" placement="top"></b-popover>
                <b-popover custom-class="missing-input-popup" :show.sync="popupTo" :disabled="popupdisabled" target="wizard-to" content="Vertragsende angeben" placement="top"></b-popover>
                <b-popover custom-class="missing-input-popup" :show.sync="popupCollectiveContract" :disabled="popupdisabled" target="wizard-collectiveContract" content="Kollektivvertrag auswählen" placement="top"></b-popover>
            </div>
            <div v-show="wizardPage == 2">
                <b-row>
                    <b-col>
                        <div class="full split-bottom">
                            <div class="header">
                                <div class="label">Urlaubsanspruch</div>
                            </div>
                            <div class="full">
                                <div class="half left">
                                    <div class="half left">
                                        <div class="label">Urlaubstage</div>
                                    </div>
                                    <div class="half cd-input" v-bind:class="{bottomline: $helpers.isEmpty(newContract.vacationTime)}">
                                        <input @focus="toggleInputPopup('vacationTime', false)" id="wizard-vacationTime" type="text" v-model="vacationTimeDays"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="full split-bottom">
                            <div class="header">
                                <div class="label">Lohn/Gehalt</div>
                            </div>
                            <div class="half left">
                                <div class="half left">
                                    <div class="label">Zahlungstyp</div>
                                </div>
                                <div @click="toggleInputPopup('paymentType', false)" class="half" style="z-index: 900;">
                                    <searchbar id="wizard-paymentType" class="filters" ref="filtersPaymentType" :searchbar="filtersPaymentType"/>
                                </div>
                            </div>
                            <div class="half left">
                                <div class="half left">
                                    <div class="label">Zahlung</div>
                                </div>
                                <div class="half cd-input" v-bind:class="{bottomline: $helpers.isEmpty(newContract.payment)}">
                                    <input @focus="toggleInputPopup('payment', false)" id="wizard-payment" type="text" v-model="newContract.payment"/>
                                </div>
                            </div>
                        </div>
                        <div class="full split-bottom">
                            <div class="half left">
                                <div class="header">
                                    <div class="label">Überstundenzuschläge</div>
                                </div>
                                <div class="full">
                                    <div class="twothirds left">
                                        <div class="label">Bonus pro Stunde</div>
                                    </div>
                                    <div class="third cd-input" v-bind:class="{bottomline: $helpers.isBlank(newContract.overtimeBonusHour)}">
                                        <input id="wizard-overtimeBonusHour" type="text" v-model="newContract.overtimeBonusHour"/>
                                    </div>
                                </div>
                                <div class="full">
                                    <div class="twothirds left">
                                        <div class="label">pauschal</div>
                                    </div>
                                    <div class="third cd-input" v-bind:class="{bottomline: $helpers.isBlank(newContract.overtimeBonusShift)}">
                                        <input id="wizard-overtimeBonusShift" type="text" v-model="newContract.overtimeBonusShift"/>
                                    </div>
                                </div>
                            </div>
                            <div class="half left">
                                <div class="header">
                                    <div class="label">Nachtarbeit & Zuschläge</div>
                                </div>
                                <div class="full">
                                    <div class="twothirds left">
                                        <div class="label">Nachtarbeiter</div>
                                    </div>
                                    <div class="third">
                                        <i class="fas fa-check-circle checkbox coredata" @click="(newContract.nightWorkerType == 1)? newContract.nightWorkerType = 2 : newContract.nightWorkerType = 1;" v-bind:class="{'true' : newContract.nightWorkerType == 2, 'false' : newContract.nightWorkerType == 1}"></i>
                                    </div>
                                </div>
                                <div class="full">
                                    <div class="twothirds left">
                                        <div class="label">Bonus pro Stunde</div>
                                    </div>
                                    <div class="third cd-input" v-bind:class="{bottomline: $helpers.isBlank(newContract.nightWorkBonusHour)}">
                                        <input id="wizard-nightWorkBonusHour" type="text" v-model="newContract.nightWorkBonusHour"/>
                                    </div>
                                </div>
                                <div class="full">
                                    <div class="twothirds left">
                                        <div class="label">pauschal</div>
                                    </div>
                                    <div class="third cd-input" v-bind:class="{bottomline: $helpers.isBlank(newContract.nightWorkBonusShift)}">
                                        <input id="wizard-nightWorkBonusShift" type="text" v-model="newContract.nightWorkBonusShift"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </b-col>
                </b-row>
                <b-popover custom-class="missing-input-popup" :show.sync="popupVacationTime" :disabled="popupdisabled" target="wizard-vacationTime" content="Urlaubsanspruch angeben" placement="top"></b-popover>
                <b-popover custom-class="missing-input-popup" :show.sync="popupPaymentType" :disabled="popupdisabled" target="wizard-paymentType" content="Zahlungstyp auswählen" placement="top"></b-popover>
                <b-popover custom-class="missing-input-popup" :show.sync="popupPayment" :disabled="popupdisabled" target="wizard-payment" content="Betrag angeben" placement="top"></b-popover>
            </div>
            <div v-show="wizardPage == 3">
                <b-row>
                    <b-col>
                        <div class="full split-bottom">
                            <div class="header">
                                <div class="label">Ab wann treten die Änderungen in Kraft?</div>
                            </div>
                            <div class="half">
                                <div class="third left">
                                    <div class="label">Gültig ab:</div>
                                </div>
                                <div class="twothirds cd-input">
                                    <input @focus="toggleInputPopup('from', false)" id="wizard-from" type="date" v-model="fromDate"/>
                                </div>
                            </div>
                        </div>
                    </b-col>
                </b-row>
                <b-popover custom-class="missing-input-popup" :show.sync="popupTo" :disabled="popupdisabled" target="wizard-to" content="Vertragsende angeben" placement="top"></b-popover>
            </div>
            <div v-show="wizardPage == 4" style="height: 200px;">
                <div class="loading">
                    <i class="fas fa-spinner"></i>
                </div>
            </div>
            <b-row>
                <b-col>
                    <div class="footer right">
                        <div v-if="wizardPage > 1" class="button next" v-bind:class="{disabled: wizardPage == 4}" @click="wizardPrev()">
                            <div class="label">Zurück</div>
                        </div>
                        <div class="button next" v-bind:class="{green: wizardPage == 3, disabled: wizardPage == 4}" @click="editWizardNext()">
                            <div class="label">{{ wizardPage >= 3? 'Speichern' : 'Weiter' }}</div>
                        </div>
                    </div>
                </b-col>
            </b-row>
        </div>
    </b-modal>
    <b-modal size="contractdetails" ref="modal-contractdetails" centered :hide-header="true" :hide-footer="true">
        <div class="wizard-popup">
            <b-row>
                <b-col>
                    <div class="header main">
                        <div class="label">Arbeitsvertrag Details</div>
                    </div>
                    <div class="close" v-on:click="hideModal('modal-contractdetails');">
                        <i class="fas fa-times"></i>
                    </div>
                </b-col>
            </b-row>
            <b-row v-if="detailContract">
                <b-col>
                    <div class="full split-bottom" v-if="parentContract(detailContract) != null">
                        <div class="header">
                            <div class="label">Vertragsänderung</div>
                        </div>
                        <div class="twothirds left">
                            <div class="label">Setzt den seit seit {{  $helpers.extractDateString(parentContract(detailContract).from, 'DD.MM.YYYY') }} gültigen Vertrag fort.</div>
                        </div>
                        <div class="third">
                            <div class="button small" @click="openDetails(parentContract(detailContract))">
                                <div class="label">
                                    Vertrag anzeigen
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="full split-bottom" v-if="childContract(detailContract) != null">
                        <div class="header">
                            <div class="label">Vertragsänderung</div>
                        </div>
                        <div class="twothirds left">
                            <div class="label">Wird ab {{  $helpers.extractDateString(childContract(detailContract).from, 'DD.MM.YYYY') }} durch eine Vertragsänderung ersetzt.</div>
                        </div>
                        <div class="third">
                            <div class="button small" @click="openDetails(childContract(detailContract))">
                                <div class="label">
                                    Vertrag anzeigen
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="full split-bottom">
                        <div class="half left">
                            <div class="header">
                                <div class="label">Vertrag</div>
                            </div>
                            <div class="full">
                                <div class="half left">
                                    <div class="label">Beruf</div>
                                </div>
                                <div class="half right">
                                    <div class="label data">{{ detailContract.jobName }}</div>
                                </div>
                            </div>
                            <div class="full">
                                <div class="half left">
                                    <div class="label">Kategorie</div>
                                </div>
                                <div class="half right">
                                    <div class="label data">{{ employeeCategoryMap[detailContract.employeeCategory] }}</div>
                                </div>
                            </div>
                            <div class="full">
                                <div class="half left">
                                    <div class="label">Vertragstyp</div>
                                </div>
                                <div class="half right">
                                    <div class="label data">{{ contractTypeMap[detailContract.contractType] }}</div>
                                </div>
                            </div>
                            <div class="full split-bottom">
                                <div class="half left">
                                    <div class="label">Anstellungsart</div>
                                </div>
                                <div class="half right">
                                    <div class="label data">{{ employmentTypeMap[detailContract.employmentType] }}</div>
                                </div>
                            </div>
                            <div class="full">
                                <div class="half left">
                                    <div class="label">Eintritt</div>
                                </div>
                                <div class="half right">
                                    <div class="label data">{{ $helpers.extractDateString(detailContract.from, 'DD.MM.YYYY') }}</div>
                                </div>
                            </div>
                            <div v-if="detailContract.probationTo" class="full" v-bind:class="{'split-bottom': !detailContract.to}">
                                <div class="half left">
                                    <div class="label">Probezeit bis</div>
                                </div>
                                <div class="half right">
                                    <div class="label data">{{ $helpers.extractDateString(detailContract.probationTo, 'DD.MM.YYYY') }}</div>
                                </div>
                            </div>
                            <div v-if="detailContract.to" class="full split-bottom-tight">
                                <div class="half left">
                                    <div class="label">Vertragsende</div>
                                </div>
                                <div class="half right">
                                    <div class="label data">{{ $helpers.extractDateString(detailContract.to, 'DD.MM.YYYY') }}</div>
                                </div>
                            </div>
                            <div class="full">
                                <div class="half left">
                                    <div class="label">Wochenstunden</div>
                                </div>
                                <div class="half right">
                                    <div class="label data">{{ minutesToHours(detailContract.weekTimeRegular) }}</div>
                                </div>
                            </div>
                            <div class="full">
                                <div class="half left">
                                    <div class="label">Arbeitstage</div>
                                </div>
                                <div class="half right">
                                    <div class="label data">{{ detailContract.weekWorkDaysRegular }}</div>
                                </div>
                            </div>
                            <div class="full">
                                <div class="half left">
                                    <div class="label">Urlaubstage</div>
                                </div>
                                <div class="half right">
                                    <div class="label data">{{ minutesToDays(detailContract.vacationTime) }}</div>
                                </div>
                            </div>
                        </div>
                        <div class="half">
                            <div class="full">
                                <div class="header">
                                    <div class="label">Zahlung</div>
                                </div>
                                <div class="half left">
                                    <div class="label">Zahlungstyp</div>
                                </div>
                                <div class="half right">
                                    <div class="label data">{{ paymentTypeMap[detailContract.paymentType] }}</div>
                                </div>
                            </div>
                            <div class="full split-bottom">
                                <div class="half left">
                                    <div class="label">Zahlung</div>
                                </div>
                                <div class="half right">
                                    <div class="label data">{{ detailContract.payment }}</div>
                                </div>
                            </div>
                            <div class="full">
                                <div class="header">
                                    <div class="label">Überstundenzuschläge</div>
                                </div>
                                <div class="half left">
                                    <div class="label">Bonus pro Stunde</div>
                                </div>
                                <div class="half right">
                                    <div class="label data">{{ detailContract.overtimeBonusHour }}</div>
                                </div>
                            </div>
                            <div class="full split-bottom">
                                <div class="half left">
                                    <div class="label">Bonus pauschal</div>
                                </div>
                                <div class="half right">
                                    <div class="label data">{{ detailContract.overtimeBonusShift }}</div>
                                </div>
                            </div>
                            <div class="full">
                                <div class="header">
                                    <div class="label">Nachtarbeit & Zuschläge</div>
                                </div>
                            </div>
                            <div class="full">
                                <div class="half left">
                                    <div class="label">Tag/Nacht</div>
                                </div>
                                <div class="half right">
                                    <div class="label data">{{ nightWorkerTypeMap[detailContract.nightWorkerType] }}</div>
                                </div>
                            </div>
                            <div class="full">
                                <div class="half left">
                                    <div class="label">Bonus pro Stunde</div>
                                </div>
                                <div class="half right">
                                    <div class="label data">{{ detailContract.nightWorkBonusHour }}</div>
                                </div>
                            </div>
                            <div class="full">
                                <div class="half left">
                                    <div class="label">Bonus pauschal</div>
                                </div>
                                <div class="half right">
                                    <div class="label data">{{ detailContract.nightWorkBonusShift }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </b-col>
            </b-row>
        </div>
    </b-modal>
    <b-modal size="employeewizard" ref="modal-endcontract" no-close-on-backdrop no-close-on-esc centered :hide-header="true" :hide-footer="true">
        <div class="wizard-popup">
            <div v-show="!loading">
            <b-row>
                <b-col>
                    <div class="header main">
                        <div class="label">Arbeitsvertrag beenden</div>
                    </div>
                    <div class="close" v-on:click="hideModal('modal-endcontract');">
                        <i class="fas fa-times"></i>
                    </div>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <div class="full split-bottom">
                        <div class="header">
                            <div class="label">Enddatum des Vertrages festlegen</div>
                        </div>
                        <div class="full">
                            <div class="label">Wenn Sie kein Enddatum auswählen wird das derzeitige Enddatum des Arbeitsvertrages entfernt.</div>
                        </div>
                        <div class="half">
                            <div class="half left">
                                <div class="label">Vertrag endet am:</div>
                            </div>
                            <div class="half cd-input">
                                <input @focus="toggleInputPopup('to', false)" id="wizard-to" type="date" v-model="endDate"/>
                            </div>
                        </div>
                    </div>
                </b-col>
            </b-row>
            <b-popover custom-class="missing-input-popup" :show.sync="popupTo" :disabled="popupdisabled" target="wizard-to" content="Vertragsende angeben" placement="top"></b-popover>
            </div>
            <div v-show="loading">
                <div style="height: 200px;">
                    <div class="loading">
                        <i class="fas fa-spinner"></i>
                    </div>
                </div>
            </div>
            <b-row>
                <b-col>
                    <div class="footer right">
                        <div class="button next red" v-bind:class="{disabled: loading}" @click="hideModal('modal-endcontract')">
                            <div class="label">Abbrechen</div>
                        </div>
                        <div class="button next green"  v-bind:class="{disabled: loading}" @click="endCurrentContract()">
                            <div class="label">Speichern</div>
                        </div>
                    </div>
                </b-col>
            </b-row>
        </div>
    </b-modal>
    <b-modal ref="modal-editorend" no-close-on-backdrop no-close-on-esc centered>
        <template slot="modal-header">
            <div class="error-modal">
                <div class="headerlabel">Arbeitsvertrag ändern</div>
            </div>
        </template>
        <b-container fluid>
            <b-row class="my-1">
                Möchten Sie Details des bestehenden Arbeitsvertrages ändern oder den Vertrag beenden?
            </b-row>
        </b-container>
        <template slot="modal-footer">
            <!-- Emulate built in modal footer ok and cancel button actions -->
            <div class="button red right" @click="hideModal('modal-editorend')">
                <div class="label">
                    Abbrechen
                </div>
            </div>
            <div class="button green right" @click="hideModal('modal-editorend'); editContract();">
                <div class="label">
                    Vertrag ändern
                </div>
            </div>
            <div class="button green right" @click="hideModal('modal-editorend'); showModal('modal-endcontract');">
                <div class="label">
                    Enddatum festlegen
                </div>
            </div>
        </template>
    </b-modal>
    <b-modal ref="modal-deletecontract" no-close-on-backdrop no-close-on-esc centered>
        <template slot="modal-header">
            <div class="error-modal">
                <div class="headerlabel">Arbeitsvertrag löschen</div>
            </div>
        </template>
        <b-container fluid>
            <b-row class="my-1">
                Sind Sie sicher dass Sie den Arbeitsvertrag löschen wollen?
            </b-row>
        </b-container>
        <template slot="modal-footer">
            <!-- Emulate built in modal footer ok and cancel button actions -->
            <div class="button red right" @click="hideModal('modal-deletecontract')">
                <div class="label">
                    Abbrechen
                </div>
            </div>
            <div class="button green right" @click="deleteContract(contractToDelete)">
                <div class="label">
                    OK
                </div>
            </div>
        </template>
    </b-modal>
    <b-form-file @input="fileSelected()" style="display:none;" hidden id="contractfile" accept="image/jpeg, image/png, application/pdf" v-model="uploadFile" ref="fileInput" class="mb-2"></b-form-file>
</div>
</template>

<script>
import grid from '../uicomponents/grid.vue'
import dropdown from '../uicomponents/dropdown.vue'
import searchbar from '../uicomponents/searchbar.vue'
export default {
    components: {
        grid,
        dropdown,
        searchbar
    },
    name: 'employeecontract',
    data() {
        return {
            
            loading: false,
            dragWatch: -1,
            mouseCurrent: {
                x: 0,
                y: 0
            },
            mouseDragStart: {
                x: 0,
                y: 0
            },
            fieldsPast: [{
                key: "icon",
                label: "",
                sortable: false,
                thClass: 'documentsTh',
                tdClass: 'documentsTd fileIconRed'
            },{
                key: "jobName",
                label: "Beruf",
                sortable: false,
                thClass: 'documentsTh',
                tdClass: 'documentsTd'
            }, {
                key: "weekTimeRegular",
                label: "Wochenstunden",
                formatter: "formattedWeekTime",
                sortable: false,
                thClass: 'documentsTh',
                tdClass: 'documentsTd'
            }, {
                key: "from",
                label: "Vertragsbeginn",
                formatter: "formattedDate",
                sortable: false,
                thClass: 'documentsTh',
                tdClass: 'documentsTd'
            }, {
                key: "to",
                label: "Vertragsende",
                formatter: "formattedDate",
                sortable: false,
                thClass: 'documentsTh',
                tdClass: 'documentsTd'
            }, {
                key: "fileId",
                label: "Dokument",
                sortable: false,
                thClass: 'documentsTh',
                tdClass: 'documentsTd'
            }, {
                key: "actions",
                label: "",
                sortable: false,
                thClass: 'documentsTh',
                tdClass: 'documentsTd'
            }],
            fieldsFuture: [{
                key: "icon",
                label: "",
                sortable: false,
                thClass: 'documentsTh',
                tdClass: 'documentsTd fileIconPlus'
            },{
                key: "jobName",
                label: "Beruf",
                sortable: false,
                thClass: 'documentsTh',
                tdClass: 'documentsTd'
            }, {
                key: "weekTimeRegular",
                label: "Wochenstunden",
                formatter: "formattedWeekTime",
                sortable: false,
                thClass: 'documentsTh',
                tdClass: 'documentsTd'
            }, {
                key: "from",
                label: "Vertragsbeginn",
                formatter: "formattedDate",
                sortable: false,
                thClass: 'documentsTh',
                tdClass: 'documentsTd'
            }, {
                key: "to",
                label: "Vertragsende",
                formatter: "formattedDate",
                sortable: false,
                thClass: 'documentsTh',
                tdClass: 'documentsTd'
            }, {
                key: "fileId",
                label: "Dokument",
                sortable: false,
                thClass: 'documentsTh',
                tdClass: 'documentsTd'
            }, {
                key: "actions",
                label: "",
                sortable: false,
                thClass: 'documentsTh',
                tdClass: 'documentsTd'
            }],
            scrolling: false,
            scrollTop: 150,
            collapseInput: false,
            collapseGrid: false,
            dropdowns: [],
            wizardPage: 1,
            newContract: {},
            popupdisabled: true,
            probationEnabled: false,
            itemsEmploymentType: [],
            filtersEmploymentType: {},
            employmentTypeMap: {},
            itemsEmployeeCategory: [],
            filtersEmployeeCategory: {},
            employeeCategoryMap: {},
            itemsContractType: [],
            filtersContractType: {},
            contractTypeMap: {},
            itemsPaymentType: [],
            filtersPaymentType: {},
            paymentTypeMap: {},
            itemsCollectiveContract: [],
            filtersCollectiveContract: {},
            collectiveContracts: [],
            collectiveContractMap: {},
            nightWorkerTypeMap: {},
            popupJobName: false,
            popupEmploymentType: false,
            popupEmployeeCategory: false,
            popupContractType: false,
            popupFrom: false,
            popupTo: false,
            popupProbationTo: false,
            popupCollectiveContract: false,
            popupVacationTime: false,
            popupPaymentType: false,
            popupPayment: false,
            contractFile: null,
            uploadFile: null,
            detailContract: null,
            uploadContractId: null,
            contractToDelete: null,
            endDate: null
        }
    },
    watch: {
        nameFilter: function (val, oldVal) {
            if (val === '') {
                this.dataFiltered = this.gridData.data.slice();
                return;
            }
            this.dataFiltered = this.gridData.data.filter(e => (e.firstName.toLowerCase() + ' ' + e.lastName.toLowerCase()).indexOf(val.toLowerCase()) > -1);
        },
        contract: function(val, oldVal){
            if(val){
                this.loadContractFile(val);
            }
        }
    },
    props: [
        "employee",
        "contract",
        "pastContracts",
        "futureContracts",
        "contractFiles",
        "uiData"
    ],
    computed: {
        fromDate: {
            get: function(){
                var dateStr;
                if(this.newContract.from){
                   
                    dateStr = this.$helpers.extractDateString(this.newContract.from);
                }
                return dateStr;
            },
            set: function(val){
                
                this.newContract.from = this.$helpers.convertDateTimeString(val);
            }
        },
        toDate: {
            get: function(){
                var dateStr;
                if(this.newContract.to){
                    
                    dateStr = this.$helpers.extractDateString(this.newContract.to);
                }
                return dateStr;
            },
            set: function(val){
                
                this.newContract.to = this.$helpers.convertDateTimeString(val);
            }
        },
        probationToDate: {
            get: function(){
                var dateStr;
                if(this.newContract.probationTo){
                    
                    dateStr = this.$helpers.extractDateString(this.newContract.probationTo);
                }
                return dateStr;
            },
            set: function(val){
               
                this.newContract.probationTo = this.$helpers.convertDateTimeString(val);
            }
        },
        vacationTimeDays: {
            get: function(){
                var val;
                if(this.newContract.vacationTime){
                    // TODO: adapt if concept for holidays defined
                    val = this.newContract.vacationTime / 60 / 24
                }
                return val;
            },
            set: function(val){
                // TODO: adapt if concept for holidays defined
                this.newContract.vacationTime = val * 24 * 60;
            }
        },
        weekTimeRegularHours: {
            get: function(){
                var val;
                if(this.newContract.collectiveContract.weekTimeRegular){
                    val = this.newContract.collectiveContract.weekTimeRegular / 60;
                }
                return val;
            },
            set: function(val){
                this.newContract.collectiveContract.weekTimeRegular = val * 60;
            }
        },
        upcomingContract: {
            get: function(){
                var val;
                for(var i = 0; i < this.futureContracts.length; i++){
                    var cur = this.futureContracts[i];
                    if(!val){
                        val = cur;
                    }else{
                        let valDate = new Date(val.from);
                        let curDate = new Date(cur.from);
                        if(curDate < valDate) val = cur;
                    }
                }
                return val;
            }
        }
    },
    created(){
        if(this.contract){
            this.loadContractFile(this.contract);
        }
    },
    destroyed() {
        
    },
    updated(){
        if(this.contract){
            if(this.contract.fileId){
                if(this.contractFile){
                    if(this.contract.fileId != this.contractFile.id) this.loadContractFile(this.contract);
                }else{
                    this.loadContractFile(this.contract);
                }
            }else{
                if(this.contractFile) this.contractFile = null;
            }
        }
    },
    mounted(){
        this.loadCollectiveContracts();
        this.setupUIDataMaps();
    },
    methods: {
        setupUIDataMaps() {
            this.uiData.employeeCategories.forEach(item => this.employeeCategoryMap[item.id] = item.label_de);
            this.uiData.contractTypes.forEach(item => this.contractTypeMap[item.id] = item.label_de);
            this.uiData.employmentTypes.forEach(item => this.employmentTypeMap[item.id] = item.label_de);
            this.uiData.paymentTypes.forEach(item => this.paymentTypeMap[item.id] = item.label_de);
            this.uiData.nightWorkerTypes.forEach(item => this.nightWorkerTypeMap[item.id] = item.label_de);
        },
        OnEnter(itemHeader, item) {
            if (itemHeader.OnEnter !== null) {
                itemHeader.OnEnter(item);
            }
        },
        ToggleEdit($event, className) {
            var list = document.querySelectorAll('.code');
            for (var x in list)
                if (!isNaN(parseInt(x))) list[x].classList.remove('edit');
            $event.currentTarget.classList.toggle('edit');
            $event.currentTarget.childNodes[1].value = '';
            $event.currentTarget.childNodes[1].focus();
        },
        EndEdit($event) {
            var list = document.querySelectorAll('.code');
            for (var x in list)
                if (!isNaN(parseInt(x))) list[x].classList.remove('edit');
        },
        ToggleClassParent($event, className) {
            $event.currentTarget.parentNode.classList.toggle(className);
        },
        ToggleDropDown: function ($event, selection, offsetx, offsety) {
            var event = $event;
            var box = event.currentTarget.getBoundingClientRect();
            var dropdowns = this.dropdowns;
            this.dropdowns.push({
                items: selection,
                el: event.currentTarget,
                remainAfterSelect: true,
                toggled: true,
                offsetx: offsetx,
                offsety: offsety,
                posx: box.left + offsetx,
                posy: box.bottom + offsety,
                onceSelected: function ($eventInner, item, dropdown) {
                    var eventInner = $eventInner;
                    var boxInner = eventInner.currentTarget.getBoundingClientRect();
                    var temp = {
                        items: item.items,
                        offsetx: offsetx + 130,
                        offsety: offsety,
                        posx: box.left + offsetx + 130,
                        toggled: true,
                        posy: boxInner.bottom - 30,
                        pointerDirection: 3,
                        parentCallback: function () {
                            dropdown.toggled = false
                        }
                    };
                    dropdowns.push(temp);
                }
            });
        },
        Init(items, config) {},
        minutesToHours(minutes){
            return minutes / 60;
        },
        minutesToDays(minutes){
            return minutes / 60 / 24;
        },
        hideModal(ref) {
            this.$refs[ref].hide()
        },
        showModal(ref) {
            this.$refs[ref].show()
        },
        openNewContractWizard(){
            this.initNewContract();
            this.wizardPage = 1;
            this.updateDropdowns();
            this.showModal('modal-createcontract');
        },
        checkContractWizardData(){
            var c = this.newContract;
            var params = null;
            var ready = true;
            var missing = []
            switch(this.wizardPage){
                case 1:
                    if(this.$helpers.isEmpty(c.jobName)) missing.push({key: 'jobName'});
                    if(this.$helpers.isEmpty(c.employmentType)) missing.push({key: 'employmentType'});
                    if(this.$helpers.isEmpty(c.employeeCategory)) missing.push({key: 'employeeCategory'});
                    if(this.$helpers.isEmpty(c.contractType)) missing.push({key: 'contractType'});
                    if(this.$helpers.isEmpty(c.from)) missing.push({key: 'from'});
                    if(this.$helpers.isEmpty(c.to) && this.newContract.employmentType == 2) missing.push({key: 'to'});
                    if(this.$helpers.isEmpty(c.probationTo) && this.probationEnabled) missing.push({key: 'probationTo'});
                    if(this.$helpers.isEmpty(c.collectiveContract)) missing.push({key: 'collectiveContract'});
                    break;
                case 2:
                    if(this.$helpers.isEmpty(c.vacationTime)) missing.push({key: 'vacationTime'});
                    if(this.$helpers.isEmpty(c.paymentType)) missing.push({key: 'paymentType'});
                    if(this.$helpers.isEmpty(c.payment)) missing.push({key: 'payment'});
                    break;
            }
            return missing;
        },
        toggleInputPopup(key, show){
            this.popupdisabled = false;
            switch(key){
                case 'jobName':
                    this.popupJobName = show;
                    break;
                case 'employmentType':
                    this.popupEmploymentType = show;
                    break;
                case 'employeeCategory':
                    this.popupEmployeeCategory = show;
                    break;
                case 'contractType':
                    this.popupContractType = show;
                    break;
                case 'from':
                    this.popupFrom = show;
                    break;
                case 'to':
                    this.popupTo = show;
                    break;
                case 'probationTo':
                    this.popupProbationTo = show;
                    break;
                case 'collectiveContract':
                    this.popupCollectiveContract = show;
                    break;
                case 'vacationTime':
                    this.popupVacationTime = show;
                    break;
                case 'paymentType':
                    this.popupPaymentType = show;
                    break;
                case 'payment':
                    this.popupPayment = show;
                    break;
            }
            this.popupdisabled = true;
        },
        wizardPrev(){
            if(this.wizardPage > 1){
                this.wizardPage = this.wizardPage - 1;
                this.updateDropdowns();
            }
        },
        wizardNext(){
            var missing = this.checkContractWizardData();
            if(missing.length == 0){
                // data complete for current page
                this.wizardPage = this.wizardPage + 1;
                this.updateDropdowns();
                if(this.wizardPage == 3){
                    this.saveEmployeeContract();
                }
            }else{
               this.toggleInputPopup(missing[0].key, true);
            }
        },
        editWizardNext(){
            var missing = this.checkContractWizardData();
            if(missing.length == 0){
                // data complete for current page
                this.wizardPage = this.wizardPage + 1;
                this.updateDropdowns();
                if(this.wizardPage == 3){
                    // reset from date
                    this.newContract.from = undefined;
                } else if(this.wizardPage == 4){
                    this.endCurrentEmployeeContractAndCreateNew(this.newContract.from);
                }
            } else{
               this.toggleInputPopup(missing[0].key, true);
            }
        },
        editContract(){
            this.initNewContract(true);
            this.wizardPage = 1;
            this.updateDropdowns();
            this.showModal('modal-editcontract');
        },
        endCurrentEmployeeContractAndCreateNew(endDate){
            this.saveEmployeeContract(view.contract.id);
            /*
            * BACKEND TAKES CARE OF UPDATING PARENT TO AND SETTING PARENT OF NEW CONTRACT
            let view = this;
            let url = '/api/sec/employeecontract';
            // TODO: Unterscheidung befristet/unbefristet je nach Enddatum und neuem Startdatum
            url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employeecontract');

            let payload = {
                id: this.contract.id,
                to: this.$helpers.convertDateTimeString(endDate),
                updateFields: ["to"]
            }
            this.axios({
                method: 'put',
                headers: {
                    'AUTHORIZATION': "bearer "+this.$store.state.jwt
                },
                url: url,
                data: payload
            }).then(response => {
                view.saveEmployeeContract(view.contract.id);
            }).catch(function (error) {
                console.log(error)
            }) */
        },
        endCurrentContract(){
            let view = this;
            let url = '/api/sec/employeecontract';
            this.loading = true;
           

            url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employeecontract');

            let payload = {
                id: this.contract.id,
                to: this.$helpers.convertDateTimeString(this.endDate),
                updateFields: ["to"]
            }
            this.axios({
                method: 'put',
                headers: {
                    'AUTHORIZATION': "bearer "+this.$store.state.jwt
                },
                url: url,
                data: payload
            }).then(response => {
                view.contract.to = view.endDate;
                view.endDate = null;
                view.loading = false;
                view.$emit('contract-updated', view.contract);
                view.hideModal('modal-endcontract');
            }).catch(function (error) {
                view.endDate = null;
                view.hideModal('modal-endcontract');
                view.loading = false;
                console.log(error);
            })
        },
        saveEmployeeContract(parentContractId=null){
            let view = this;
            let url = '/api/sec/employeecontract';
            url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employeecontract');

            let payload = {
                storeId: this.$store.state.storeId,
                employeeId: this.employee.id,
            }
            if(!this.$helpers.isBlank(this.newContract.jobName)){
                payload.jobName = this.newContract.jobName;
            }
            console.log(this.newContract.from);

            payload.from = this.newContract.from;
            payload.to = this.newContract.to;
            payload.probationTo = this.newContract.probationTo;
            payload.paymentType = this.newContract.paymentType;
            payload.payment = this.newContract.payment;
            payload.weekTimeRegular = this.newContract.weekTimeRegular;
            payload.weekWorkDaysRegular = this.newContract.weekWorkDaysRegular;
            payload.vacationTime = this.newContract.vacationTime;
            payload.employeeCategory = this.newContract.employeeCategory;
            payload.employmentType = this.newContract.employmentType;
            payload.contractType = this.newContract.contractType;
            payload.nightWorkerType = this.newContract.nightWorkerType;
            payload.nightWorkBonusHour = this.newContract.nightWorkBonusHour;
            payload.nightWorkBonusShift = this.newContract.nightWorkBonusShift;
            payload.overtimeBonusHour = this.newContract.overtimeBonusHour;
            payload.overtimeBonusShift = this.newContract.overtimeBonusShift;
            if(!this.$helpers.isBlank(this.newContract.comment)){
                payload.comment = this.newContract.comment;
            }

            // selected collectiveContract --> this.newContract.collectiveContract;
            // TODO: clarify if and how to pass collective contract data

            let specificData = {};
            /*
            if(!this.$helpers.isBlank(this.employeeContract.costCenter)){
                specificData.costCenter = this.employeeContract.costCenter;
            }
            
            if(this.newContract.collectiveContract){
                specificData.collectiveContractId = this.newContract.collectiveContract.id;
            }
            if(this.employeeContract.employmentType === 3){
                specificData.apprenticeYear = this.employeeContract.apprenticeYear;
            }
            */
            payload.specificData = specificData;

            this.axios({
                method: 'post',
                headers: {
                    'AUTHORIZATION': "bearer "+this.$store.state.jwt
                },
                url: url,
                data: payload
            }).then(response => {
                view.hideModal('modal-createcontract');
                view.hideModal('modal-editcontract');
                view.$emit('contract-added', response.data.data);
            }).catch(function (error) {
                console.log(error)
            })
        },
        updateDropdowns(){
            switch(this.wizardPage){
                case 1:
                    this.updateEmploymentTypeDropdown();
                    this.updateEmployeeCategoryDropdown();
                    this.updateContractTypeDropdown();
                    this.updateCollectiveContractDropdown();
                    break;
                case 2:
                    this.updatePaymentTypeDropdown();
                    break;
            }
        },
        updateEmploymentTypeDropdown(){
            var view = this;
            this.itemsEmploymentType = [];
            // dropdown data country
            for(const val of this.uiData.employmentTypes){
                this.itemsEmploymentType.push({code: val.id, label: val.label_de, name: val.label_de});
            }
            this.filtersEmploymentType = {
                toggled: false,
                displayedItems: this.itemsEmploymentType,
                input: this.newContract.employmentType != undefined? this.employmentTypeMap[this.newContract.employmentType] : 'bitte wählen',
                items: Object.values(this.itemsEmploymentType),
                onceSelected: function ($event, item, searchbar){
                    view.newContract.employmentType = item.code;
                },
                inheritedStyle: this.inheritedSearchbarStyle,
            }
        },
        updateEmployeeCategoryDropdown(){
            var view = this;
            this.itemsEmployeeCategory = [];
            // dropdown data country
            for(const val of this.uiData.employeeCategories){
                this.itemsEmployeeCategory.push({code: val.id, label: val.label_de, name: val.label_de});
            }
            this.filtersEmployeeCategory = {
                toggled: false,
                displayedItems: this.itemsEmployeeCategory,
                input: this.newContract.employeeCategory != undefined? this.employeeCategoryMap[this.newContract.employeeCategory] : 'bitte wählen',
                items: Object.values(this.itemsEmployeeCategory),
                onceSelected: function ($event, item, searchbar){
                    view.newContract.employeeCategory = item.code;
                },
                inheritedStyle: this.inheritedSearchbarStyle,
            }
        },
        updateContractTypeDropdown(){
            var view = this;
            this.itemsContractType = [];
            // dropdown data country
            for(const val of this.uiData.contractTypes){
                this.itemsContractType.push({code: val.id, label: val.label_de, name: val.label_de});
            }
            this.filtersContractType = {
                toggled: false,
                displayedItems: this.itemsContractType,
                input: this.newContract.contractType != undefined? this.contractTypeMap[this.newContract.contractType] : 'bitte wählen',
                items: Object.values(this.itemsContractType),
                onceSelected: function ($event, item, searchbar){
                    view.newContract.contractType = item.code;
                },
                inheritedStyle: this.inheritedSearchbarStyle,
            }
        },
        updateCollectiveContractDropdown(){
            var view = this;
            this.itemsCollectiveContract = [];
            // dropdown data country
            for(const val of this.collectiveContracts){
                this.itemsCollectiveContract.push({code: val, label: val.name, name: val.name, obj: val});
            }
            this.filtersCollectiveContract = {
                toggled: false,
                displayedItems: this.itemsCollectiveContract,
                input: this.newContract.collectiveContract != undefined? this.newContract.collectiveContract.name : 'bitte wählen',
                items: Object.values(this.itemsCollectiveContract),
                onceSelected: function ($event, item, searchbar){
                    view.newContract.collectiveContract = item.obj;
                    view.newContract.weekTimeRegular = item.obj.weekTimeRegular;
                    view.newContract.weekWorkDaysRegular = item.obj.weekWorkDaysRegular;
                },
                inheritedStyle: this.inheritedSearchbarStyle,
            }
        },
        updatePaymentTypeDropdown(){
            var view = this;
            this.itemsPaymentType = [];
            // dropdown data country
            for(const val of this.uiData.paymentTypes){
                this.itemsPaymentType.push({code: val.id, label: val.label_de, name: val.label_de});
            }
            this.filtersPaymentType = {
                toggled: false,
                displayedItems: this.itemsPaymentType,
                input: this.newContract.paymentType != undefined? this.paymentTypeMap[this.newContract.paymentType] : 'bitte wählen',
                items: Object.values(this.itemsPaymentType),
                onceSelected: function ($event, item, searchbar){
                    view.newContract.paymentType = item.code;
                },
                inheritedStyle: this.inheritedSearchbarStyle,
            }
        },
        initNewContract(copyExisting=null){
            if(copyExisting){
                this.newContract = this._.clone(this.contract);
                this.newContract.id = undefined;
                this.newContract.probationTo = undefined;
                this.newContract.approved = false;
            }else{
                this.newContract = {
                    approved: false,
                    comment: "",
                    contractType: undefined,
                    employeeCategory: undefined,
                    employeeId: this.employee.id,
                    employmentType: undefined,
                    from: undefined,
                    to: undefined,
                    jobName: undefined,
                    nightWorkerType: 1,
                    nightWorkBonusHour: 0,
                    nightWorkBonusShift: 0,
                    overtimeBonusHour: 0,
                    overtimeBonusShift: 0,
                    payment: undefined,
                    paymentType: undefined,
                    probationTo: undefined,
                    vacationTime: 36000,
                    weekTimeRegular: undefined,
                    weekWorkDaysRegular: undefined,
                    collectiveContract: undefined
                }
            }
        },
        inheritedSearchbarStyle(el) {
            $(el).find('.entry').css({
                'width': '100%',
                'position': 'absolute',
                'top': '0px',
                'left': '0px',
                'height': '18px',
                'padding': '0px 1px',
                'color': 'var(--contrast-3)',
            });
            $(el).find('.fa-stack').css({
                'top': '0px',
                'margin-top': '0px',
                'margin-right': '4px',
                'right': '0px'
            });
            $(el).find('input').css({
                'box-shadow': 'none',
                'background': 'none'
            });
            $(el).find('.fa-angle-down').css({
                'color': '#ffffff'
            });
            $(el).find('.fa-circle').css({
                'color': 'var(--contrast-2)'
            });
            $(el).find('.items').css({
                position: 'absolute',
                top: '19px',
                left: '-1px',
                width: 'calc(100% + 2px)',
                'box-shadow': 'none',
            });
            $(el).find('.items .item:even').css({
                background: 'var(--contrast-1)'
            });
            $(el).find('.items .item:odd').css({
                background: 'var(--bg)'
            });
            $(el).find('.items .item').css({
                padding: '4px 0px 4px 4px'
            });
            $(el).find('.item .label').css({
                color: 'var(--contrast-5)',
                'font-size': '10px',
                'margin-top': '0px'
            });
        },
        loadCollectiveContracts : function() {
      
            let url = '/api/semi/collectivecontract';

            this.axios({
                method: 'get',
                headers: {
                    'AUTHORIZATION': "bearer "+this.$store.state.jwt
                },
                url: url
            }).then((response) => {
                this.updateCollectiveContracts(response.data);
            });
        },
        updateCollectiveContracts: function(data){
            let collectiveContractMap = {};
            let collectiveContracts = [];
            for (let i = 0; i < data.length; i++) {
                collectiveContractMap[data[i].id] =data[i];
                collectiveContracts.push(data[i]);
            }
            this.collectiveContractMap = collectiveContractMap;
            this.collectiveContracts = collectiveContracts;
        },
        loadContractFile(contract) {
            if(contract.fileId){
                let fileId = contract.fileId;
                let view = this;
                let url = '/api/sec/employeefile';

                url = this.$helpers.appendParam("id", fileId, url, '/api/sec/employeefile');
                url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employeefile');
                url = this.$helpers.appendParam("employeeId", this.$props.employeeId, url, '/api/sec/employeefile');

                this.axios({
                    method: 'get',
                    headers: {
                        'AUTHORIZATION': "bearer " + this.$store.state.jwt
                    },
                    url: url
                }).then((response)=>{
                    if(this.contract && this.contract.id == contract.id){
                        this.contractFile = response.data;
                        this.$forceUpdate();
                    }else{
                        var f = response.data;
                        this.contractFiles[f.id] = f;
                    }
                });
            }else{
                this.contractFile = null;
                this.$forceUpdate();
            }
        },
        openContractFile(){
            let url = this.contractFile.url+'/api/file?id='+this.contractFile.fileId+'&accessToken='+this.contractFile.accessToken;
            window.open(url, '_blank');
        },
        loadAndOpenContractFile(contract) {
            if(contract.fileId){
                let fileId = contract.fileId;
                let view = this;
                let url = '/api/sec/employeefile';

                url = this.$helpers.appendParam("id", fileId, url, '/api/sec/employeefile');
                url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employeefile');
                url = this.$helpers.appendParam("employeeId", this.$props.employeeId, url, '/api/sec/employeefile');

                this.axios({
                    method: 'get',
                    headers: {
                        'AUTHORIZATION': "bearer " + this.$store.state.jwt
                    },
                    url: url
                }).then((response)=>{
                    var f = response.data;
                    let url = f.url+'/api/file?id='+f.fileId+'&accessToken='+f.accessToken;
                    window.open(url, '_blank');
                });
            }
        },
        selectFileForUpload(contract){
            this.uploadContractId = contract.id;
            var elem = document.getElementById('contractfile');
            elem.click();
        },
        fileSelected(){
            var view = this;
            if(this.uploadFile){
                this.fileerror = false;
                let view = this;
                let url = '/api/sec/employeefile/upload';
                url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employeefile/upload');
                let contractFilename = "Contract_"+this.uploadContractId;

                let formData = new FormData();
                formData.append("employeeId", this.employee.id);
                formData.append("name", contractFilename);
                formData.append("documentType", 'CONTRACT');
                formData.append('file', this.uploadFile);

                this.uploading = true;
                this.axios({
                    method: 'post',
                    headers: {
                        'AUTHORIZATION': "bearer " + this.$store.state.jwt
                    },
                    url: url,
                    data: formData
                }).then(response => {
                    let file = response.data.data;
                    view.updateFileId(view.uploadContractId, file);
                    view.$emit('file-added', view.uploadContractId, file);
                    view.uploading = false;
                    view.linkFileToContract(view.uploadContractId, file.id);
                }).catch(function (error) {
                    view.fileerror = true;
                    view.uploading = false;
                    console.log(error)
                })
            }
        },
        updateFileId(contractId, file){
            if(this.contract && this.contract.id == contractId){
                this.contract.fileId = file.id;
                this.contractFile = file;
            }
        },
        linkFileToContract(contractId, fileId){
            this.fileerror = false;
            let view = this;
            let url = '/api/sec/employeecontract';
            url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employeecontract');
            url = this.$helpers.appendParam("employeeId", this.employee.id, url, '/api/sec/employeecontract');

            let payload = {
                id: contractId,
                fileId: fileId,
                updateFields: ["fileId"]
            };
            this.axios({
                method: 'put',
                headers: {
                    'AUTHORIZATION': "bearer " + this.$store.state.jwt
                },
                url: url,
                data: payload
            }).then(response => {
                view.$forceUpdate();
            }).catch(function (error) {
                view.fileerror = true;
                console.log(error)
            });
        },
        unlinkContractFile(){
            var fileId = this.contract.fileId;
            this.$emit('contract-deleted', fileId);
        },
        checkApprovalDate(contract){
            if(this.contract && contract.id == this.contract.id){
                if(this.contract.approvalDate){
                    let fileDate = new Date(this.contractFile.creationDate);
                    let approvalDate = new Date(this.contract.approvalDate);
                    return fileDate < approvalDate;
                }
            }else{
                if(contract.approvalDate){
                    var contractFile = this.contractFiles[contract.fileId];
                    if(contractFile){
                        let fileDate = new Date(contractFile.creationDate);
                        let approvalDate = new Date(contract.approvalDate);
                        return fileDate < approvalDate;
                    }
                }
            }
            return true;
        },
        approveContractFile(contract){
            var contractId = contract.id;
            let view = this;
            let url = '/api/sec/employeecontract/approve';
            url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employeecontract/approve');
            url = this.$helpers.appendParam("id", contractId, url, '/api/sec/employeecontract/approve');

            let payload = {
                id: contractId
            };

            this.axios({
                method: 'put',
                headers: {
                    'AUTHORIZATION': "bearer " + this.$store.state.jwt
                },
                url: url,
                data: payload
            }).then(response => {
                if(view.contract && view.contract.id == contract.id){
                    view.contract.approved = true;
                }
                view.$emit('contract-approved', contractId);
                view.$forceUpdate();
            }).catch(function (error) {
                view.fileerror = true;
                console.log(error)
            });
        },
        openDetails(c){
            this.detailContract = c;
            this.showModal('modal-contractdetails');
        },
        contractWithId(contractId){
            if(this.contract.id == contractId) return this.contract;
            var allContracts = this.pastContracts.concat(this.futureContracts);
            for(var i = 0; i < allContracts.length; i++){
                if(allContracts[i].id == contractId) return allContracts[i];
            }
            return null;
        },
        parentContract(contract){
            if(contract.parentId) return this.contractWithId(contract.parentId);
        },
        childContract(contract){
            var parentId = contract.id;
            if(this.contract && this.contract.parentId == parentId) return this.contract;
            var allContracts = this.pastContracts.concat(this.futureContracts);
            for(var i = 0; i < allContracts.length; i++){
                var cur = allContracts[i];
                if(cur && cur.parentId == parentId) return cur;
            }
            return null;
        },
        deleteContract(contract){
        let view = this;
        let url = '/api/sec/employeecontract';
        
        url = this.$helpers.appendParam("id", contract.id, url, '/api/sec/employeecontract');
        url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employeecontract');
        
        this.axios({
            method: 'delete',
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url
        }).then(response => {
            view.hideModal('modal-deletecontract');
            view.$emit('contract-deleted', contract.id);
        }).catch(function (error) {
            console.log(error)
        })

    },
        formattedDate(str){
            return this.$helpers.extractDateString(str, "DD.MM.YYYY");
        },
        formattedWeekTime(mins){
            return (mins / 60) + " Stunden"
        }
    }
}
</script>

<style scoped>
.searchbar.filters {
    height: 18px !important;
    display: block;
    margin-top: 4px;
    width: 100%;
}
</style>